import store from '@/store';
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-unresolved */
const routes = [
  {
    name: 'publisher-application-report',
    path: '/publisher/application/report',
    component: () => import('@/views/publisher/Report.vue'),
    props: () => ({ publisherId: store.state.auth.login.publisher }),
  },
  {
    name: 'application-report',
    path: '/application/:applicationId/report',
    component: () => import('@/views/application/Report.vue'),
    props: true,
  },
  {
    path: '*',
    component: () => import('@/views/main/NotFound.vue'),
  },
];

export default routes;
